import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19.661 4.75H4.339c-.7 0-1.268.652-1.268 1.457v11.587c0 .805.568 1.456 1.268 1.456h15.322c.7 0 1.268-.651 1.268-1.456V6.207c0-.804-.568-1.457-1.268-1.457zM8.809 15.871V8.129l7.839 3.87-7.839 3.871z"
}), 'Youtube');